import { library } from '@fortawesome/fontawesome-svg-core';
import { faCirclePlay, faChevronLeft, faChevronRight, faChevronUp, faChevronDown, faExchange, faBoxOpen,
  faCodeCompare, faChartLine, faExclamationTriangle, faCloudUploadAlt, faCamera } from '@fortawesome/free-solid-svg-icons';

library.add(faCirclePlay, faChevronLeft, faChevronRight, faChevronUp, faChevronDown, faExchange, faBoxOpen,
  faCodeCompare, faChartLine, faExclamationTriangle, faCloudUploadAlt, faCamera);
